<template>
  <div v-if="$route.meta.ribbon" class="ribbonContainer">
    <div class="row position-relative" >
      <div class="col-md-3 ribbon">
    <span class="ribbon3 text-center">
      <span>{{ $store.getters['breadcrumbs'] ? $store.getters['breadcrumbs'].length > 0 ? $store.getters['breadcrumbs'][0].title  : '' : '' }}</span>
    </span>
      </div>
      <div class="col-md ml-auto">
        <button @click="goToCore" class="float-right position-absolute"
                style="left: 1.8rem;z-index: 1;top: 1.8rem;">
          <i class="fa fa-times text-danger"></i>
        </button>
      </div>
    </div>
  </div>

</template>

<script>
import router from "@/router";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

export default {
    name: "titleRibbon",
    methods: {
      goToCore() {
        router.push({name: 'dashboard'})
      }
    },
}
</script>

<style scoped>
.ribbon {
    width: 100%;
    float: right;
    margin-bottom: 0;
    text-transform: uppercase;
    color: white;
    z-index: 1;

}

.ribbon:nth-child(even) {
    margin-right: 4%;
}

@media (max-width: 500px) {
    .ribbon {
        width: 100%;
    }

    .ribbon:nth-child(even) {
        margin-right: 0%;
    }
}

.ribbon3 {
    width: 200px;
    height: 50px;
    line-height: 50px;
    padding-left: 15px;
    position: absolute;
    right: -1px;
    background: rgb(238, 49, 138);
}

.ribbon3:before, .ribbon3:after {
    content: "";
    position: absolute;
}

.ribbon3:before {
    height: 0;
    width: 0;
    top: -7.5px;
    right: 0;
    border-bottom: 9px solid black;
    border-left: 9px solid transparent;
}

.ribbon3:after {
    height: 0;
    width: 0;
    left: -14.5px;
    border-top: 25px solid transparent;
    border-bottom: 25px solid transparent;
    border-right: 15px solid rgb(238, 49, 138);

}

/*.ribbon5 {*/
/*    position: absolute;*/
/*    top: -5.1px;*/
/*    left: 20px;*/
/*}*/

/*.ribbon5:after {*/
/*    position: absolute;*/
/*    content: "";*/
/*    width: 0;*/
/*    height: 0;*/
/*    border-left: 53px solid transparent;*/
/*    border-right: 53px solid transparent;*/
/*    border-top: 10px solid rgb(238, 49, 138);*/
/*}*/

/*.ribbon5 span {*/
/*    position: relative;*/
/*    display: block;*/
/*    text-align: center;*/
/*    background: rgb(238, 49, 138);*/
/*    font-size: 14px;*/
/*    line-height: 1;*/
/*    padding: 12px 8px 10px;*/
/*    border-top-right-radius: 8px;*/
/*    width: 90px;*/
/*}*/

/*.ribbon5 span:before, .ribbon5 span:after {*/
/*    position: absolute;*/
/*    content: "";*/
/*}*/

/*.ribbon1 span:before {*/
/*    height: 6px;*/
/*    width: 6px;*/
/*    left: -6px;*/
/*    top: 0;*/
/*    background: rgb(238, 49, 138);*/
/*}*/

/*.ribbon1 span:after {*/
/*    height: 6px;*/
/*    width: 12px;*/
/*    left: -8px;*/
/*    top: 0;*/
/*    border-radius: 8px 8px 0 0;*/
/*    background: rgb(238, 49, 138);*/
/*}*/
.ribbonContainer{
  position: relative;
  height: 80px;
  background-color: white;
  margin-bottom: -1rem;
  z-index: 1;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
</style>